import React from "react";
import { motion } from "framer-motion";
import VerifiedIcon from "@mui/icons-material/Verified";
import "./RecognizedBySection.css";

// --- Sample Data ---
const companies = [
  {
    name: "Google",
    logo: "https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg",
  },
  {
    name: "Microsoft",
    logo: "https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg",
  },
  {
    name: "Amazon",
    logo: "https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg",
  },
  {
    name: "Meta",
    logo: "https://upload.wikimedia.org/wikipedia/commons/a/ab/Meta-Logo.svg",
  },
  {
    name: "Netflix",
    logo: "https://upload.wikimedia.org/wikipedia/commons/0/08/Netflix_2015_logo.svg",
  },
  {
    name: "Apple",
    logo: "https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg",
  },
  {
    name: "Tesla",
    logo: "https://upload.wikimedia.org/wikipedia/commons/e/e8/Tesla_logo.png",
  },
];

const jobRoles = [
  {
    company: "Tech Solutions Inc.",
    title: "Frontend Developer",
    salary: "₹12,00,000 P.A.",
  },
  {
    company: "Innovate Co.",
    title: "React Developer",
    salary: "₹14,00,000 P.A.",
  },
  {
    company: "Creative Minds LLC",
    title: "UI/UX Engineer",
    salary: "₹13,50,000 P.A.",
  },
  {
    company: "Data Systems",
    title: "Software Engineer",
    salary: "₹15,00,000 P.A.",
  },
  {
    company: "Web Weavers",
    title: "Full Stack Developer",
    salary: "₹16,00,000 P.A.",
  },
  {
    company: "Cloud Creations",
    title: "DevOps Engineer",
    salary: "₹17,00,000 P.A.",
  },
];

// --- Carousel Component ---
const Carousel = ({ items, renderItem, baseVelocity = 2 }) => {
  const duplicatedItems = [...items, ...items];

  return (
    <div className="recognizedBySection_carouselContainer">
      <motion.div
        className="recognizedBySection_carousel"
        animate={{
          x: ["0%", "-100%"],
          transition: {
            ease: "linear",
            duration: 50,
            repeat: Infinity,
          },
        }}
      >
        {duplicatedItems.map((item, index) => (
          <div className="recognizedBySection_card" key={index}>
            {renderItem(item)}
          </div>
        ))}
      </motion.div>
    </div>
  );
};

// --- Main Component ---
const RecognizedBySection = ({ title }) => {
  return (
    <div className="recognizedBySection_wrapper">
      <div className="recognizedBySection_iconWrapper">
        <VerifiedIcon
          sx={{ marginBottom: "10px" }}
          className="recognizedBySection_verifiedIcon"
        />
      </div>
      <div className="recognizedBySection_content">
        <h2 className="recognizedBySection_title">
          {title ?? "Our Certificate is recognised by 1200+ Top Companies"}
        </h2>

        <Carousel
          items={companies}
          renderItem={(company) => (
            <>
              <img
                src={company.logo}
                alt={`${company.name} logo`}
                className="recognizedBySection_companyLogo"
              />
              <p className="recognizedBySection_companyName">{company.name}</p>
            </>
          )}
        />

        <div className="recognizedBySection_divider">
          <span className="recognizedBySection_dividerText">
            Roles You will be Eligible For
          </span>
        </div>

        <Carousel
          items={jobRoles}
          renderItem={(role) => (
            <div className="recognizedBySection_roleCard">
              <h3 className="recognizedBySection_roleCompany">
                {role.company}
              </h3>
              <p className="recognizedBySection_roleTitle">{role.title}</p>
              <p className="recognizedBySection_roleSalary">{role.salary}</p>
            </div>
          )}
          baseVelocity={-2}
        />
      </div>
    </div>
  );
};

export default RecognizedBySection;
